import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import { IBrokerEntity } from '../../entitites/broker.entity';
import { TeamDto } from '../../shared';

export class BrokerService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async getAll(path: string) {
    return this.get<Array<IBrokerEntity>>(path, 'broker');
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return this.getMany<IBrokerEntity>(path, search, 'broker');
  }

  public async find(guid: string) {
    return this.get<IBrokerEntity>(guid, 'broker');
  }

  public async getSelf() {
    return this.get<IBrokerEntity>('brokers/self', 'get broker self');
  }

  public async getTeams() {
    return this.get<Array<TeamDto>>('teams', 'get Teams');
  }
}
